import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {Component, inject, OnInit, ViewChild} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { FormularioService } from '../../../services/database/formulario.service';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, DEFAULT_DATE_FORMAT, FormNoData, ICustomTable, IHeader, LoadingPanelService, LocalService } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormulariosHistoricoComponent } from './formularios-historico/formularios-historico.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-formularios',
  standalone: true,
  imports: [
    CommonModule, TableModule, FormsModule, CustomTableComponent, FormulariosHistoricoComponent, CustomTitle, TranslateModule,
    ButtonModule, SkeletonModule, ToastModule, ConfirmPopupModule, InputTextModule, CheckboxModule,
  ],
  providers: [ConfirmationService, MessageService],
  template: `
    <p-confirmPopup></p-confirmPopup>
    <section class="flex justify-content-center mt-4">
      <div class="card-table col-12 pt-6">
        <div >
            <CustomTitle [title]="'common.formularios' | translate"
                         styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
        </div>
        <custom-table [config]="customTable">
        </custom-table>
      </div>
    </section>

    <app-formularios-historico></app-formularios-historico>
  `
})
export class FormulariosComponent implements OnInit {
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(FormulariosHistoricoComponent) historico !: FormulariosHistoricoComponent;
  role = AccessRole;

  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor(private readonly formDB: FormularioService, private readonly confirmationService: ConfirmationService, private readonly messageService: MessageService, private readonly _t: TranslateService,
    public readonly ls: LocalService, private readonly _router: Router, private readonly _lps: LoadingPanelService) {
  }

  ngOnInit(): void {
    this.titleService.changeTitle('common.formularios')
    this.translate();
    this.getForms();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      formularios: this._t.get('common.formularios'),
      nombre: this._t.get('common.nombre'),
      descripcion: this._t.get('common.descripcion'),
      fechaCreacion: this._t.get('common.fechaCreacion'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      tieneTipoTramite: this._t.get('common.tieneTipoTramite'),
      categoria: this._t.get('common.categoria'),
      version: this._t.get('common.version'),
    }));
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'categoria',
          header: this.trans.categoria,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          class: 'brand-table-tag mx-auto my-auto font-13',
          dataType: DataColumnType.CUSTOM,
          sort: true,
          columnFilter: true
        },
        {
          field: 'nombre',
          header: this.trans.nombre,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          class: 'font-13',
          truncate: true,
          width: '10rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'version',
          header: this.trans.version,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'tieneTipoTramite',
          header: this.trans.tieneTipoTramite,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          dataType: DataColumnType.CHECK,
          sort: true,
        },
        {
          field: 'fechaCreacion',
          header: this.trans.fechaCreacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          width: '13rem',
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '13rem',
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: FormNoData) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          icon: 'pi pi-file-edit',
          class: 'button-edit p-button-outlined pt-2 pb-2 pl-1 pr-1',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: FormNoData) => this.onClick(data),
          disabled: !this.ls.hasRole(this.role.ADMIN_FORM),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_FORM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: FormNoData) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNew(),
            disabled: !this.ls.hasRole(this.role.ADMIN_FORM),
          },
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  private openNew(): void {
    const url = '#/configuracion/formulario/edit';
    window.open(url, '_blank');

  }

  private onClick(data: FormNoData) {
    const url = `#/configuracion/formulario/edit/${data.id}`
    window.open(url, '_blank');
  }

  deleteConfirmation(event: Event, data: FormNoData) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure that you want to Delete?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteForm(data.id);
      },
      reject: () => {

      }
    });
  }

  abrirHistorial(data: FormNoData): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }

  //#region API Calls
  getForms(): void {
    this.formDB.getFormsNoData().subscribe({
      next: (data: FormNoData[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  private deleteForm(formId: number) {
    this._lps.show(true);
    this.formDB.deleteForm(formId).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this.messageService.add({ severity: 'success', summary: 'Formulario Eliminado', detail: response });
        this.getForms();
      }
    });
  }
  //#endregion API Calls

}
